import { FC, PropsWithChildren, ReactNode } from 'react';
import { Typography } from '@mui/material';

import useStyles from './styles';

type Props = {
  title: string;
  children: ReactNode;
};

const FilterSection: FC<PropsWithChildren<Props>> = ({ title, children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="bodyLgBold" component="span">
        {title}
      </Typography>
      <div className={classes.filters}>{children}</div>
    </div>
  );
};

export default FilterSection;
